import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { ACTIVE_STATUSES, HISTORIC_STATUSES } from "../models/incidents";
import { UI_TIMESTAMP_FORMAT } from "../../../../utils/date.helpers";

dayjs.extend(customParseFormat);

function allowedStatusesByActiveHistoric(activeHistoric) {
  if (activeHistoric === "ACTIVE") return ACTIVE_STATUSES;
  if (activeHistoric === "HISTORIC") return HISTORIC_STATUSES;
  return [...ACTIVE_STATUSES, ...HISTORIC_STATUSES];
}

export function applyIncidentFilters(incidents, filters) {
  const { dateRange, priorities, statuses, activeHistoric, reporters } = filters;

  const [from, to] = dateRange || [null, null];
  const allowedByAH = allowedStatusesByActiveHistoric(activeHistoric);

  const prioritySet = new Set(priorities || []);
  const statusSet = new Set(statuses || []);
  const reporterSet = new Set(reporters || []);

  return incidents.filter((inc) => {
    if (!allowedByAH.includes(inc.status)) return false;
    if (statusSet.size > 0 && !statusSet.has(inc.status)) return false;
    if (prioritySet.size > 0 && !prioritySet.has(inc.priority)) return false;
    if (reporterSet.size > 0 && !reporterSet.has(inc.reporter)) return false;
    if (from || to) {
      const incTime = dayjs(inc.timestamp, UI_TIMESTAMP_FORMAT, true);
      if (!incTime.isValid()) return false;

      if (from && incTime.isBefore(from)) return false;
      if (to && incTime.isAfter(to)) return false;
    }

    return true;
  });
}
